import {
  animate,
  animateChild,
  group,
  query,
  style,
  transition,
  trigger,
} from '@angular/animations';

// Slide left and fade in/out.
const slideLeft = [
  style({ position: 'relative', overflow: 'hidden' }),
  query(
    ':enter, :leave',
    [
      style({
        position: 'absolute',
        margin: '16px 8px',
        left: 0,
        width: '100%',
        overflow: 'hidden',
      }),
    ],
    { optional: true },
  ),
  query(':enter', [style({ left: '100%', opacity: 0 })], { optional: true }),
  query(':leave', animateChild(), { optional: true }),
  group([
    query(
      ':leave',
      [animate('250ms ease-in-out', style({ left: '-100%', opacity: 0 }))],
      {
        optional: true,
      },
    ),
    query(
      ':enter',
      [animate('250ms ease-in-out', style({ left: '0%', opacity: 1 }))],
      {
        optional: true,
      },
    ),
  ]),
];

// Slide right and fade in/out.
const slideRight = [
  style({ position: 'relative', overflow: 'hidden' }),
  query(
    ':enter, :leave',
    [
      style({
        position: 'absolute',
        margin: '16px 8px',
        left: 0,
        width: '100%',
        overflow: 'hidden',
      }),
    ],
    { optional: true },
  ),
  query(':enter', [style({ left: '-100%', opacity: 0 })], { optional: true }),
  query(':leave', animateChild(), { optional: true }),
  group([
    query(
      ':leave',
      [animate('250ms ease-in-out', style({ left: '100%', opacity: 0 }))],
      {
        optional: true,
      },
    ),
    query(
      ':enter',
      [animate('250ms ease-in-out', style({ left: '0%', opacity: 1 }))],
      {
        optional: true,
      },
    ),
  ]),
];

/** Slide from right when home->sequence->flight-details. From left when opposite. */
export const routeAnimations = trigger('routeAnimations', [
  transition(':increment', slideLeft),
  transition(':decrement', slideRight),
  transition('* => *', [style({ opacity: 0 }), animate('600ms ease-in-out')]),
]);
